import { ListItemButton } from '@mui/material';
import { SearchAndSelectType } from './SearchAndSelect.component';

export type SearchAndSelectOptionType<T> = {
  option: T;
} & Pick<SearchAndSelectType<T>, 'getOptionLabel' | 'renderListItem' | 'onOptionSelect'>;

const defaultGetOptionLabel = () => '';

export const SearchAndSelectOption = <T extends { id: string }>({
  getOptionLabel = defaultGetOptionLabel,
  renderListItem,
  onOptionSelect,
  option
}: SearchAndSelectOptionType<T>) => {
  const label = getOptionLabel(option);

  if (renderListItem) {
    return (
      <>
        {renderListItem(option)}
      </>
    );
  } else {
    return (
      <ListItemButton onClick={() => onOptionSelect?.(option)}>
        {label}
      </ListItemButton>
    );
  }
};
